import { useState } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableRow,
  TableCell,
  HeadingLevel,
  WidthType,
  // Column,
} from "docx";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import fetchMethodRequest from "../../../../config/service";
import { Dialog } from "primereact/dialog";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useSearchParams } from "react-router-dom";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import configMessages from "../../../../config/configMessages";
import apiCalls from "../../../../config/apiCalls";


const TestCaseGeneratorComponent = ({ generateCasesFormOpen, setGenerateCasesFormOpen, fetchModules, getDataFromServer }) => {
  const [file, setFile] = useState(null);
  const [model, setModel] = useState("openai");
  const [response, setResponse] = useState(null);
  const [filePath, setFilePath] = useState(null);

  const [loading, setLoading] = useState(false);

  const [searchParams] = useSearchParams();
  const moduleId = searchParams.get("module");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("model", model);

    try {
      setLoading(true);
      const url = "testCases/generateTestCasesContent";
      const res = await fetchMethodRequest("POST", url, formData);
      setResponse(res.data);
      setFilePath(res.filePath)
    } catch (err) {
      console.error(err);
      showToasterMessage("❌ Error saving test cases", "error");
    } finally {
      setLoading(false);
    }
  };

  const saveDataToServer = async () => {
    try {
      setLoading(true);
      let testCasesArray = response.test_cases.map((testCase) => ({ ...testCase, moduleId: moduleId, filePath: filePath ? filePath : "" }));
      const url = `${apiCalls.testCases}/saveGeneratedTestCases`
      const res = await fetchMethodRequest("POST", url, { testCases: testCasesArray });
      fetchModules();
      let filterCriteria = { limit: 50, page: 1, criteria: [], direction: 'desc', softfield: 'created' }
      filterCriteria.criteria.push({
        key: "moduleId",
        value: moduleId,
        type: "eq"
      });
      getDataFromServer(filterCriteria);
      setGenerateCasesFormOpen(false);

      if (res.respCode) showToasterMessage(configMessages.testCasesSave, "success");
    } catch (err) {
      console.error(err);
      showToasterMessage("❌ Error saving test cases", "error");
    } finally {
      setLoading(false);
    }
  }

  const header = () => {
    return (
      <div className="d-flex align-items-center gap-2">
        <svg fill="currentColor" height="20" width="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            clip-rule="evenodd"
            d="M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z"
            fill-rule="evenodd"
          ></path>
        </svg>
        <h4>AI Test Case Generator</h4>
      </div>
    )
  }
  const columns = [
    { field: "testCaseID", header: "Test Case ID", width: "8%", sortable: true },
    { field: "category", header: "Category", width: "10%", sortable: true },
    { field: "title", header: "Title", width: "14%", sortable: true },
    { field: "description", header: "Description", width: "16%" },
    { field: "preconditions", header: "Preconditions", width: "15%" },
    { field: "steps", header: "Steps", width: "20%", isHtml: true },
    { field: "expectedResult", header: "Expected Result", width: "18%" },
    { field: "priority", header: "Priority", width: "5%", sortable: true }
  ];

  return (
    <Dialog
      header={header()}
      visible={generateCasesFormOpen}
      style={{ width: "50vw" }}
      modal
      draggable={false}
      onHide={() => setGenerateCasesFormOpen(false)}
    >

      <div style={{ height: "20%", margin: "10px" }}>
        <form onSubmit={handleSubmit} className="row g-3 align-items-center mb-3">
          <div className="col-md-6">
            <input
              type="file"
              accept=".pdf,.docx"
              className="form-control"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </div>

          {/* For Future use cases using multiple ai models */}

          {/* <div className="col-md-4">
            <select
              className="form-select"
              value={model}
              disabled={response}
              onChange={(e) => setModel(e.target.value)}
              style={{ height: "30px", fontSize: "12px" }}
            >
              <option value="openai">OPEN AI</option>
              <option value="perplexity">Perplexity</option>
              <option value="gemini">Gemini</option>
            </select>
          </div> */}
          <div className="col-md-6">
            <button
              type="button"
              className="btn btn-primary  mt-3 "
              style={{ height: "30px", fontSize: "12px" }}
              onClick={() => setResponse(null)}>
              RESET
            </button>
            <button
              type="button"
              className="btn btn-primary mt-3"
              style={{ height: "30px", fontSize: "12px" }}
              onClick={() => saveDataToServer()}
            >
              Save
            </button>

            <button
              type="submit"
              className="btn btn-primary mt-3"
              disabled={loading}
              style={{ height: "30px", fontSize: "12px" }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Generating...
                </>
              ) : (
                "Generate"
              )}
            </button>
          </div>

        </form>
      </div>

      {/* Results Display */}
      {response && (
        <div style={{ height: "100%" }}>
          <div className="mt-5">
            <div>
              {response && Array.isArray(response?.test_cases) && (
                <div className="mt-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="text-secondary fw-semibold mb-0">Generated Test Cases</h5>
                  </div>

                  <DataTable
                    value={response?.test_cases}
                    stripedRows
                    scrollable
                    scrollHeight="65vh"
                    className="p-0 p-datatable-table p-datatable-scrollable-table p-datatable-resizable-table"
                    tableStyle={{ minWidth: '70rem', fontSize: '12px', padding: '0' }}
                  >
                    {columns.map((col) => (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        sortable={col.sortable}
                        style={{ width: col.width }}
                        body={
                          col.isHtml
                            ? (rowData) => (
                              <div
                                dangerouslySetInnerHTML={{ __html: rowData[col.field] }}
                              />
                            )
                            : undefined
                        }
                      />
                    ))}
                  </DataTable>

                </div>
              )}
            </div>

          </div>
        </div>
      )}

    </Dialog>


  );
};

export default TestCaseGeneratorComponent;
